export const mapDotsData = [
  {
    x: 64,
    y: 61,
    title: 'Jackson, AL'
  },
  {
    x: 51.7,
    y: 62.8,
    title: 'Garland, TX'
  },
  {
    x: 13,
    y: 29.5,
    title: 'Happy Valley, OR'
  },
  {
    x: 72.5,
    y: 30.5,
    title: 'Detroit, MI'
  },
  {
    x: 6,
    y: 46.5,
    title: 'Fremont, CA'
  },
  {
    x: 50.5,
    y: 54.5,
    title: 'Tulsa, OK'
  },
  {
    x: 48.3,
    y: 43.7,
    title: 'Ellsworth, KS'
  },
  {
    x: 56.8,
    y: 47.9,
    title: 'Springfield, MO'
  },
  {
    x: 35,
    y: 47,
    title: 'Littleton, CO'
  },
  {
    x: 63,
    y: 27.8,
    title: 'Sheboygan, WI'
  },
  {
    x: 83.5,
    y: 29.4,
    title: 'Henrietta, NY'
  },
  {
    x: 29.5,
    y: 61.3,
    title: 'Albuquerque, NM'
  },
  {
    x: 69,
    y: 47,
    title: 'Jeffersontown, KY'
  },
  {
    x: 61.5,
    y: 53.6,
    title: 'Dyersburg, TN'
  },
];


// WEBPACK FOOTER //
// ./src/data/customer-analysis.js